import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function RescheduleModal({ plan, onClose, onSave }) {
  const [newDate, setNewDate] = useState('');
  const remaining = plan.planned_quantity - (plan.completed_quantity || 0);

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" data-testid="reschedule-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-slate-800">Reschedule</h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="w-5 h-5" /></button>
        </div>
        <div className="space-y-3">
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
            <p className="text-sm font-medium text-purple-800">{plan.material_description || plan.project_name}</p>
            <p className="text-xs text-purple-600 flex items-center gap-1 mt-1">
              {remaining} remaining <ArrowRight className="w-3 h-3" /> move to new date
            </p>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600">New Date</label>
            <input type="date" value={newDate} onChange={e => setNewDate(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 text-sm mt-1" data-testid="reschedule-date-input" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button onClick={onClose} className="px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded-lg">Cancel</button>
            <button onClick={() => { if (newDate) onSave(plan.id, newDate); else toast.error('Select a date'); }}
              className="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-testid="reschedule-save-btn">Reschedule</button>
          </div>
        </div>
      </div>
    </div>
  );
}
